import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const USERS_SIDENAV_LINKS = new InjectionToken<void>("USERS_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "Users",
        icon: "users",
        label: "SETTINGS.ITEMS.USERS",
        expanded: true,
        items: [
          {
            id: "Employees",
            label: "SETTINGS.ITEMS.EMPLOYEES",
            routerLink: "/settings/employees",
            permissions: COMMON_GUARD_OPTIONS.EMPLOYEE.VIEW.permissions,
          },
          {
            id: "Brokers",
            label: "SETTINGS.ITEMS.BROKERS",
            routerLink: "/settings/brokers",
            permissions: COMMON_GUARD_OPTIONS.BROKER.VIEW.permissions,
          },
          {
            id: "TelecomsOperators",
            label: "SETTINGS.ITEMS.TELECOM_OPERATORS",
            routerLink: "/settings/telecom-operators",
            permissions: COMMON_GUARD_OPTIONS.TELECOM_OPERATOR.VIEW.permissions,
          },
        ],
      },
    ]);
  },
});
